import { useEffect, useMemo } from "react";

function useGoogleAdsReload(slotId: string[], reload: any[]) {
  const dependencies = useMemo(() => [...reload], [JSON.stringify(reload)]);
  const memoizedSlotId = useMemo(() => [...slotId], [JSON.stringify(slotId)]);

  const hasMarketingConsent = (): boolean => {
    const activeGroups = (window as any).OnetrustActiveGroups || "";
    return activeGroups.split(",").includes("C0004");
  };

  const initAdRefresh = () => {
    if (window.googletag?.cmd?.push) {
      console.log("Refreshing specific Ad on Pagination Change...");

      window.googletag.cmd.push(() => {
        const isPersonalized = hasMarketingConsent();

        const pubadsService = window.googletag.pubads();
        pubadsService.setRequestNonPersonalizedAds(isPersonalized ? 0 : 1);

        const slotsToRefresh = pubadsService
          .getSlots()
          .filter((s: any) => memoizedSlotId.includes(s.getSlotElementId()));

        if (slotsToRefresh.length > 0) {
          pubadsService.refresh(slotsToRefresh);
        } else {
          console.warn("Ad slot not found!");
        }
      });
    }
  };

  const waitForOneTrustAndRefresh = () => {
    if (typeof window === "undefined") return;

    if ((window as any).OnetrustActiveGroups) {
      initAdRefresh();
    } else {
      const originalWrapper = (window as any).OptanonWrapper;
      (window as any).OptanonWrapper = () => {
        if (typeof originalWrapper === "function") originalWrapper();
        initAdRefresh();
      };
    }
  };

  useEffect(() => {
    waitForOneTrustAndRefresh();
  }, [memoizedSlotId, dependencies]);

  return "";
}

export default useGoogleAdsReload;
